import MetaCRMTag from "@metacrm/metacrm-material-ui/dist/MetaCRMTag";
import { Box } from "@mui/material";
import { formatDate } from "features/helpers/utils";
import { get } from "lodash-es";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useTheme } from "@mui/styles";

export default function useGetImportTable() {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const headers = [
    {
      title: "Import Time",
      label: formatMessage({ id: "importHistory.headline.importTime" }),
      disabledSort: true,
      show: true,
      id: "importTime",
    },
    {
      title: "Name/Smart Contract Address",
      label: formatMessage({ id: "importHistory.headline.sourceName" }),
      disabledSort: true,
      show: true,
      id: "name",
    },
    {
      title: "Import Method",
      label: formatMessage({ id: "importHistory.headline.importMethod" }),
      disabledSort: true,
      show: true,
      id: "importMethod",
    },
    {
      title: "User Count",
      label: formatMessage({ id: "importHistory.headline.userCount" }),
      disabledSort: true,
      show: true,
      id: "userCount",
    },
    {
      title: "Status",
      label: formatMessage({ id: "importHistory.headline.status" }),
      disabledSort: true,
      show: true,
      id: "status",
    },
    {
      title: "Tag(s)",
      label: formatMessage({ id: "importHistory.headline.tags" }),
      disabledSort: true,
      show: true,
      id: "tags",
    },
  ];

  const renderContents = (history) => {
    const importMethodMap = {
      contract: formatMessage({ id: "importHistory.method.contract" }),
      csv: formatMessage({ id: "importHistory.method.csv" }),
      singleUser: formatMessage({ id: "importHistory.method.single" }),
    };

    const name =
      history.type === "csv"
        ? history?.csvFilename.split("/").pop()
        : history.type === "contract"
        ? history?.contractName || history?.contractAddress
        : formatMessage({ id: "cdp.source.manualInput" });

    // Status rendering logic with four statuses
    const getStatusDisplay = (status) => {
      const statusConfig = {
        pending: {
          color: theme.customColors.grey[500],
          label: formatMessage({ id: "global.status.pending" }),
        },
        processing: {
          color: "#FFC814",
          label: formatMessage({ id: "global.status.processing" }),
        },
        failed: {
          color: theme.customColors.pink[600],
          label: formatMessage({ id: "global.status.failed" }),
        },
        done: {
          color: theme.customColors.green[500],
          label: formatMessage({ id: "global.status.completed" }),
        },
      };

      const config = statusConfig[status] || statusConfig.failed;

      return (
        <Box
          className="item-flex"
          sx={{ alignItems: "center", flexWrap: "nowrap" }}
          fontSize={12}
          color="#222"
        >
          <Box
            bgcolor={config.color}
            width="8px"
            height="8px"
            mr="5px"
            borderRadius="50%"
          />
          {config.label}
        </Box>
      );
    };

    let contents = [
      <div slot="importTime">
        {formatDate(history.importTime, { time: true }) || "-"}
      </div>,
      <div slot="name">{name}</div>,
      <div slot="importMethod">{importMethodMap[history?.type] || "-"}</div>,
      <div slot="userCount">{history?.addressCount || "-"}</div>,
      <div slot="status">{getStatusDisplay(history?.source?.status)}</div>,
      <div slot="tags" onClick={(e) => e.stopPropagation()}>
        {history.tagIds?.length > 0 ? (
          <>
            <Box className="item-flex">
              {history.tagIds?.slice(0, 2).map((tag) => (
                <MetaCRMTag
                  key={tag.value}
                  option={{
                    color: get(tag, "color", "#E6E6E6"),
                    label: tag.value,
                  }}
                />
              ))}
              {history?.tagIds?.length > 2 && (
                <Box color="#7b61ff" fontSize={12} ml="4px">
                  +{history.tags.length - 2}
                </Box>
              )}
            </Box>
          </>
        ) : (
          "-"
        )}
      </div>,
    ];
    return contents;
  };
  return {
    headers,
    renderContents,
  };
}
